


















































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import GameModule from '@/store/modules/Game';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
  },
})
export default class RiskManagementList extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Game name',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Netwin configs',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Multiplier configs',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'RTP alert',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'RTP close game',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Manage',
        attr: {
          class: 'text-left',
        },
      },
    ],
  ];

  GameInstance = getModule(GameModule, this.$store);

  data = [];

  valueConfigs = {
    prefix: '',
    riskConfig: {
      netWin: 0,
      multiplier: 0,
      rtpAlert: 0,
      rtpCloseGame: 0,
    },
    type: '',
  };

  query = '';

  riskNetWin = 0;

  riskMultiplier = 0;

  riskModal = false;

  typeList: string [] = [];

  type = 'all';

  created() {
    this.fetchGame();
  }

  async fetchGame() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.FetchRiskManagementList({ prefix: this.query });
    if (res.code) {
      this.checkError(res);
    } else {
      const games = res.filter((v) => v.partner === 'AMBSLOT');
      games.forEach((element) => {
        // eslint-disable-next-line no-param-reassign
        if (!this.typeList.includes(element.type)) this.typeList = [...this.typeList, element.type];
      });
      if (this.type !== 'all') {
        this.data = games.filter((v) => v.type === this.type);
      } else {
        this.data = games;
      }
    }
    this.GeneralInstance.toggleLoading(false);
  }

  editConfig(val) {
    this.valueConfigs = val;
    this.riskModal = true;
  }

  async handleRiskManagement(val) {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.UpdateRiskManagementConfigs(
      {
        multiplier: Number(val.riskConfig.multiplier),
        netWin: Number(val.riskConfig.netWin),
        rtpAlert: Number(val.riskConfig.rtpAlert),
        rtpCloseGame: Number(val.riskConfig.rtpCloseGame),
        prefix: this.valueConfigs.prefix,
      },
    );
    if (res.code === 0) {
      this.checkError(res);
    } else {
      this.errorHandle(res.code, res);
    }
    this.riskModal = false;
    this.fetchGame();
    this.GeneralInstance.toggleLoading(false);
  }

  errorHandle(code, message) {
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
  }

  handleChange() {
    this.fetchGame();
  }
}
